import {Category} from '../types';

export function getUniqueCategories<T extends {categories: Category[]}>(
  items: T[],
): Category[] {
  const allCategories = items.flatMap(item => item.categories);
  return [
    ...new Map(allCategories.map(category => [category.id, category])).values(),
  ];
}
